module.exports = __webpack_public_path__ + "static/media/21ECLAC42.67a602b8.jpg";